import FeatureController from '../FeatureController';

export default class HomeController extends FeatureController {

  constructor (panel, $state) {
    super(panel, $state);
    this.endpoint = '/v1/matches/ideal';
    this.initSearch();
  }

  set_option (object, option) {
      let preferences = this.preferences[option];
      let index = this.options[option].indexOf(object);
      if (preferences && preferences.indexOf(object.id) > -1){
          this.options[option][index].selected = 1;
          return;
      }
      this.options[option][index].selected = 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/features/home/HomeController.js